import React, { useEffect, useState } from 'react';
import { FuseNavigation, FuseUtils } from '@fuse';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import { API_BASE_URL } from '@config';
import { getLmsConfig } from 'app/main/settings/store/actions/lms.actions';

const useStyles = makeStyles(()=> ({
	root: {
		'overflow-x': 'hidden'
	}
}));

const Navigation = props => {
	const navigation = useSelector(({ fuse }) => fuse.navigation);
	const user = useSelector(({ auth }) => auth.user);
	const lmsEnabled = useSelector(({ settings }) => !!(settings && settings.lms && settings.lms.config && settings.lms.config.enabled));
	const dispatch = useDispatch();
	const classes = useStyles();

	// "Heidi LMS" shows ONLY for organization admins AND only when this installation
	// has the LMS turned on (Settings > Configuration > Heidi LMS, default off).
	// Super-admins carry the 'admin' role too, so the role-based nav auth alone
	// cannot exclude them; we mirror the backend rule (organizationId + admin + NOT
	// super-admin) and additionally require the per-installation toggle.
	const roles = (user && Array.isArray(user.role)) ? user.role : [];
	const isOrgAdmin = !!(user && user.organizationId && roles.includes('admin') && !roles.includes('super-admin'));

	// Only org admins ever see the item, so only they need the (silent) status check.
	useEffect(() => {
		if (isOrgAdmin) dispatch(getLmsConfig());
	}, [dispatch, isOrgAdmin]);

	// "Imaging" is a lens on DICOM series and scientific image stacks. With
	// neither it is an empty screen that cannot be filled from there, so it is
	// hidden - unlike Storage itself, which stays visible because that is how
	// someone discovers the feature.
	//
	// null until the answer arrives, and null SHOWS the item. Treating "not yet
	// known" as "none" would blink the entry out of the menu on every page load,
	// and hide it permanently for anyone whose check failed.
	const [hasImaging, setHasImaging] = useState(null);
	useEffect(() => {
		let cancelled = false;
		axios.get(`${API_BASE_URL}/api/storage/feature`, { skipForbiddenToast: true })
			.then((r) => { if (!cancelled) setHasImaging(!!(r.data && r.data.hasImaging)); })
			.catch(() => { /* leave it null: show the item rather than lose it */ });
		return () => { cancelled = true; };
	}, []);


	let nav = navigation;
	if (!(isOrgAdmin && lmsEnabled)) nav = FuseUtils.removeNavItem(nav, 'heidi-lms');
	if (hasImaging === false) nav = FuseUtils.removeNavItem(nav, 'storage-imaging');
	// The Storage section stays VISIBLE even where the feature is off or not in
	// the organization's plan. Discovery is the point: this is how an admin
	// learns the feature exists, and each page explains what to do about it -
	// activate it, or ask whoever can. Only the pages change, never the menu.

	return (
		<FuseNavigation
			className={clsx(classes.root, 'navigation', props.className)}
			navigation={nav}
			layout={props.layout}
			dense={props.dense}
		/>
	);
};

Navigation.defaultProps = {
	layout: 'vertical'
};

export default Navigation;
